<template>
  <div @click="handleFavorite">
    <div v-if="isMobile">
      <OButton
        class="u-center border rounded-3xl border-[#E2E5ED] text-sm font-medium text-primary-200 py-2 px-4 mr-2"
        :class="`${isActive ? 'bg-[#306aff] text-white' : 'favorite-nonactive bg-white text-primary-200'}`"
        pure
      >
        <ORawIcon
          ref="hoverPopperTrigger"
          :icon="`${isActive ? 'article/favorite-checked' : 'article/favorite-nonchecked'}`"
          class="mr-1"
          :class="`${isActive ? 'bg-[#306aff] text-white' : 'bg-white'}`"
          :aria-label="isActive ? $t('main.remove-favorites') : $t('main.add-favorites')"
          @mouseover="hoverPopper.show"
          @mouseleave="hoverPopper.hide"
        />
        <span>{{ $t('main.favorite') }}</span>
      </OButton>
    </div>
    <div v-else class="relative mt-2">
      <ORawIcon
        ref="hoverPopperTrigger"
        :icon="`${isActive ? 'article/favorite-checked' : 'article/favorite-nonchecked'}`"
        class="article-favorite-icon w-11 h-11 rounded-full u-center cursor-pointer overflow-hidden border border-[#E2E5ED]"
        :class="`${isActive ? 'bg-[#306aff] text-white' : 'bg-white text-primary-200'}`"
        :aria-label="isActive ? $t('main.remove-favorites') : $t('main.add-favorites')"
        @mouseover="hoverPopper.show"
        @mouseleave="hoverPopper.hide"
      />
    </div>
    <OPopper ref="hoverPopperView" :is-visible="hoverPopper.visible" class="bg-body-primary xborder xborder-red-500 min-w-24" use-show>
      <div class="text-right text-xxs py-0.5">{{ isActive ? $t('main.remove-favorites') : $t('main.add-favorites') }}</div>
    </OPopper>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, useContext } from '@nuxtjs/composition-api';
import { OPopper, OButton, OIcon, ORawIcon } from '@/modules/common/components/ui';
import { usePopper } from '~/composables/usePopper';
import { useDialog, useModal } from '~/composables/useModal';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: {
    OPopper,
    OButton,
    OIcon,
    ORawIcon,
  },
  props: {
    article: {
      type: Object,
      require: true,
    },
  },
  setup({ article }) {
    const { $service } = useContext();
    const { sendDetayInteractionEvent } = onedioEvents();
    const { isMobile } = useDevice();
    const { openLoginModal } = useModal();
    const { openErrorDialog } = useDialog();
    const { isLoggedIn } = useAuth();
    const [hoverPopperTrigger, hoverPopperView, hoverPopper] = usePopper({ offset: [0, 0], placement: 'top-end' });
    const isActive = ref(false);
    onMounted(async () => {
      if (!isLoggedIn.value) {
        isActive.value = false;
        return;
      }
      try {
        const { data } = await $service.article.getFavoriteStatus(article._id);
        isActive.value = data;
      } catch (error) {
        isActive.value = false;
      }
    });
    const handleFavorite = async () => {
      if (!isLoggedIn.value) {
        await openLoginModal();
        return;
      }
      try {
        if (!isActive.value) {
          await $service.article.favoriteArticle(article._id);
          sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Kaydet');
          isActive.value = true;
        } else {
          await $service.article.unfavoriteArticle(article._id);
          isActive.value = false;
        }
      } catch (error) {
        openErrorDialog({ error });
        isActive.value = false;
      }
    };
    return {
      isActive,
      isMobile,
      //
      handleFavorite,
      hoverPopperTrigger,
      hoverPopperView,
      hoverPopper,
    };
  },
});
</script>
